var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { backgroundImageUrls, defaultBackgroundConfig, } from '../../../virtual-background/helpers/backgroundHelper';
import useResumableFilesUpload from '../../../../helpers/hooks/useResumableFilesUpload';
import useBodyPix from '../../../virtual-background/hooks/useBodyPix';
const BackgroundItems = ({ onSelect }) => {
    _react_refresh_temp_2();
    // we'll require making ready virtual background
    // elements as early as possible.
    useBodyPix();
    const allowedFileTypes = ['jpg', 'jpeg', 'png'];
    const { t } = useTranslation();
    const [selectedBg, setSelectedBg] = useState(defaultBackgroundConfig);
    const [bgImgs, setBgImgs] = useState(backgroundImageUrls);
    const [files, setFiles] = useState();
    const customFileRef = useRef(null);
    const { isUploading, result } = useResumableFilesUpload({
        allowedFileTypes,
        maxFileSize: '30',
        files,
    });
    useEffect(() => {
        if (result && result.filePath) {
            const path = window.PLUG_N_MEET_SERVER_URL +
                '/download/uploadedFile/' +
                result.filePath;
            const newBgImgs = [...bgImgs];
            newBgImgs.push(path);
            setBgImgs([...newBgImgs]);
            const el = customFileRef.current;
            if (el) {
                el.value = '';
            }
        }
    }, [result, customFileRef]);
    const handleOnClick = (type, url) => {
        const bg = {
            type,
            url,
        };
        setSelectedBg(bg);
        onSelect(bg);
    };
    const customBgImage = (e) => {
        if (isUploading) {
            return;
        }
        const files = e.target.files;
        if (!files) {
            return;
        }
        setFiles([...files]);
    };
    return (_jsxs("div", { className: "flex flex-wrap items-center justify-start p-3 bg-slate-100 dark:bg-transparent shadow-header", children: [_jsx("div", { className: `cursor-pointer rounded-md w-[62px] h-[62px] overflow-hidden flex items-center justify-center border-2 border-solid border-gray-300 dark:border-primaryColor transition transform scale-90 hover:scale-95 ease-in  ${selectedBg.type === 'none'
                    ? 'border-[#24aef7] dark:border-[#24aef7] scale-95'
                    : ''}`, onClick: () => handleOnClick('none', ''), children: _jsx("i", { className: "pnm-ban-solid dark:text-darkSecondary2" }) }), _jsx("div", { className: `cursor-pointer rounded-md w-[62px] h-[62px] overflow-hidden flex items-center justify-center border-2 border-solid border-gray-300 dark:border-primaryColor transition transform scale-90 hover:scale-95 ease-in ${selectedBg.type === 'blur'
                    ? 'border-[#24aef7] dark:border-[#24aef7] scale-95'
                    : ''}`, onClick: () => handleOnClick('blur', ''), children: _jsx("i", { className: "pnm-blur dark:text-darkSecondary2" }) }), bgImgs.map((imageUrl, i) => {
                return (_jsx("div", { className: `cursor-pointer rounded-md w-[62px] h-[62px] overflow-hidden flex items-center justify-center transition transform scale-90 hover:scale-95 ease-in border-2 border-solid border-transparent ${selectedBg.url === imageUrl ? 'border-[#24aef7] scale-95' : ''}`, onClick: () => handleOnClick('image', imageUrl), children: _jsx("img", { src: imageUrl, alt: `bg-${i + 1}`, className: `object-cover w-full h-full` }) }, imageUrl));
            }), _jsxs("div", { className: "upload-btn-wrap relative overflow-hidden inline-block cursor-pointer pt-2 w-full", children: [_jsx("button", { className: "btn border border-dotted border-[#24aef7] bg-transparent py-2 px-4 rounded text-xs text-secondaryColor cursor-pointer", children: t('footer.modal.upload-background-image') }), _jsx("input", { className: "absolute left-0 top-0 opacity-0 w-full h-full cursor-pointer", ref: customFileRef, type: "file", onChange: customBgImage, accept: allowedFileTypes.map((file) => '.' + file).join(',') })] })] }));
};
_react_refresh_temp_1 = BackgroundItems;
$RefreshReg$(_react_refresh_temp_1, "BackgroundItems");
_react_refresh_temp_2(BackgroundItems, "IIZxp2Fv4ilUP/Q6uQMWUlDxYXw=", false, () => [
    // we'll require making ready virtual background
    // elements as early as possible.
    useBodyPix, useTranslation, useResumableFilesUpload]);
export default BackgroundItems;
